import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _applyCouponRequest = {};
var _applyCouponResponse = {
    subTotal: 'DOUBLE',
    discount: 'DOUBLE',
    total: 'DOUBLE',
};
var _bulkAddAllToProgramRequest = {};
var _bulkAddAllToProgramResponse = {};
var _bulkAddToProgramRequest = {};
var _bulkAddToProgramResponse = { results: '_bulkAddToProgramResult' };
var _bulkAddToProgramResult = { item: '_participant' };
var _bulkApproveAllParticipantRequest = {};
var _bulkApproveAllParticipantResponse = {};
var _bulkApproveParticipantRequest = {};
var _bulkApproveParticipantResponse = {
    results: '_bulkApproveParticipantResult',
};
var _bulkApproveParticipantResult = { item: '_participant' };
var _bulkInviteAllToProgramRequest = {};
var _bulkInviteAllToProgramResponse = {};
var _bulkInviteToProgramRequest = {};
var _bulkInviteToProgramResponse = { results: '_bulkInviteToProgramResult' };
var _bulkInviteToProgramResult = { item: '_participant' };
var _certificate = { issuedDate: 'google.protobuf.Timestamp' };
var _completeParticipantRequest = {};
var _completeParticipantResponse = { participant: '_participant' };
var _deleteParticipantRequest = {};
var _deleteParticipantResponse = {};
var _exportParticipantsStatsRequest = {};
var _exportParticipantsStatsResponse = {};
var _getAccessStatusRequest = {};
var _getAccessStatusResponse = {};
var _getCompletionStatsRequest = {};
var _getCompletionStatsResponse = { completionRate: 'DOUBLE' };
var _getParticipantRequest = {};
var _getParticipantResponse = { participant: '_participant' };
var _getPremiumStatsRequest = {};
var _getPremiumStatsResponse = {};
var _issueCertificateRequest = {};
var _issueCertificateResponse = { participant: '_participant' };
var _joinProgramRequest = {};
var _joinProgramResponse = { participant: '_participant' };
var _leaveProgramRequest = {};
var _leaveProgramResponse = {};
var _participant = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    progress: '_progress',
    certificate: '_certificate',
};
var _progress = { completionPercentage: 'DOUBLE' };
var _queryParticipantsRequest = {};
var _queryParticipantsResponse = { participants: '_participant' };
var _revertCouponRequest = {};
var _revertCouponResponse = { total: 'DOUBLE' };
function resolveWixOnlineprogramsParticipantsV3ParticipantExportsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Member joins the program. By the type of program, participant in corresponding
 * state will be created.
 */
export function joinProgram(payload) {
    var _a = serializer(_joinProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinProgramResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __joinProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.JoinProgram',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/join',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinProgram.fromReq = fromReq;
    __joinProgram.__isAmbassador = true;
    return __joinProgram;
}
/** Returns participant. */
export function getParticipant(payload) {
    var _a = serializer(_getParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipantResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __getParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.GetParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getParticipant.fromReq = fromReq;
    __getParticipant.__isAmbassador = true;
    return __getParticipant;
}
/** Participant leaves program. Entity will be deleted. Idempotent call. */
export function leaveProgram(payload) {
    var _a = serializer(_leaveProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveProgramResponse, {}).fromJSON;
    function __leaveProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.LeaveProgram',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/leave',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leaveProgram.fromReq = fromReq;
    __leaveProgram.__isAmbassador = true;
    return __leaveProgram;
}
/** Query existing participants */
export function queryParticipants(payload) {
    var _a = serializer(_queryParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryParticipantsResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __queryParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.QueryParticipants',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryParticipants.fromReq = fromReq;
    __queryParticipants.__isAmbassador = true;
    return __queryParticipants;
}
/** Get access status */
export function getAccessStatus(payload) {
    var _a = serializer(_getAccessStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccessStatusResponse, {}).fromJSON;
    function __getAccessStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.GetAccessStatus',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/access',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccessStatus.fromReq = fromReq;
    __getAccessStatus.__isAmbassador = true;
    return __getAccessStatus;
}
/** Apply coupon to order */
export function applyCoupon(payload) {
    var _a = serializer(_applyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyCouponResponse, {}).fromJSON;
    function __applyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.ApplyCoupon',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/coupons/{couponCode}/apply',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyCoupon.fromReq = fromReq;
    __applyCoupon.__isAmbassador = true;
    return __applyCoupon;
}
/** Remove coupon from order */
export function revertCoupon(payload) {
    var _a = serializer(_revertCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_revertCouponResponse, {}).fromJSON;
    function __revertCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.RevertCoupon',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/coupons/{couponId}/revert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __revertCoupon.fromReq = fromReq;
    __revertCoupon.__isAmbassador = true;
    return __revertCoupon;
}
/**
 * Bulk invites participants to program.
 * For each member participant in Invited state is created.
 */
export function bulkInviteToProgram(payload) {
    var _a = serializer(_bulkInviteToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkInviteToProgramResponse, {
        _bulkInviteToProgramResult: _bulkInviteToProgramResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkInviteToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkInviteToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/invite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkInviteToProgram.fromReq = fromReq;
    __bulkInviteToProgram.__isAmbassador = true;
    return __bulkInviteToProgram;
}
/**
 * Bulk invites all participants to program, but not more then 1000.
 * For each member participant in Invited state is created.
 */
export function bulkInviteAllToProgram(payload) {
    var _a = serializer(_bulkInviteAllToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkInviteAllToProgramResponse, {}).fromJSON;
    function __bulkInviteAllToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkInviteAllToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/invite-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkInviteAllToProgram.fromReq = fromReq;
    __bulkInviteAllToProgram.__isAmbassador = true;
    return __bulkInviteAllToProgram;
}
/**
 * Bulk adds participants to program.
 * Participant will be either created in state Joined, or updated to that state
 * from pending one.
 */
export function bulkAddToProgram(payload) {
    var _a = serializer(_bulkAddToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddToProgramResponse, {
        _bulkAddToProgramResult: _bulkAddToProgramResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkAddToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkAddToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddToProgram.fromReq = fromReq;
    __bulkAddToProgram.__isAmbassador = true;
    return __bulkAddToProgram;
}
/**
 * Bulk adds all site members to program, but not more then 1000.
 * Participant will be either created in state Joined, or updated to that state
 * from pending one.
 */
export function bulkAddAllToProgram(payload) {
    var _a = serializer(_bulkAddAllToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddAllToProgramResponse, {}).fromJSON;
    function __bulkAddAllToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkAddAllToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/add-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddAllToProgram.fromReq = fromReq;
    __bulkAddAllToProgram.__isAmbassador = true;
    return __bulkAddAllToProgram;
}
/**
 * Bulk approves participants, who asked to join private program (aka in
 * state `APPROVAL_PENDING`). If participant was in other state, no effect and
 * error returned.
 */
export function bulkApproveParticipant(payload) {
    var _a = serializer(_bulkApproveParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkApproveParticipantResponse, {
        _bulkApproveParticipantResult: _bulkApproveParticipantResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkApproveParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkApproveParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkApproveParticipant.fromReq = fromReq;
    __bulkApproveParticipant.__isAmbassador = true;
    return __bulkApproveParticipant;
}
/**
 * Bulk approves all pending participants, who asked to join private program (aka
 * in state `APPROVAL_PENDING`).
 */
export function bulkApproveAllParticipant(payload) {
    var _a = serializer(_bulkApproveAllParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkApproveAllParticipantResponse, {}).fromJSON;
    function __bulkApproveAllParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkApproveAllParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/approve-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkApproveAllParticipant.fromReq = fromReq;
    __bulkApproveAllParticipant.__isAmbassador = true;
    return __bulkApproveAllParticipant;
}
/**
 * Delete participant from program by owner will. Removes participant from member
 * group. Leaves him in Social Group.
 */
export function deleteParticipant(payload) {
    var _a = serializer(_deleteParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteParticipantResponse, {}).fromJSON;
    function __deleteParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'DELETE',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.DeleteParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteParticipant.fromReq = fromReq;
    __deleteParticipant.__isAmbassador = true;
    return __deleteParticipant;
}
/** Issue certificate by site admin */
export function issueCertificate(payload) {
    var _a = serializer(_issueCertificateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_issueCertificateResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __issueCertificate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.IssueCertificate',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/issue-certificate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __issueCertificate.fromReq = fromReq;
    __issueCertificate.__isAmbassador = true;
    return __issueCertificate;
}
/** Get program's completion stats */
export function getCompletionStats(payload) {
    var _a = serializer(_getCompletionStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCompletionStatsResponse, {}).fromJSON;
    function __getCompletionStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.GetCompletionStats',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/stats/completion/{programId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCompletionStats.fromReq = fromReq;
    __getCompletionStats.__isAmbassador = true;
    return __getCompletionStats;
}
/** Get premium stats */
export function getPremiumStats(payload) {
    var _a = serializer(_getPremiumStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPremiumStatsResponse, {}).fromJSON;
    function __getPremiumStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.GetPremiumStats',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/stats/premium',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPremiumStats.fromReq = fromReq;
    __getPremiumStats.__isAmbassador = true;
    return __getPremiumStats;
}
/**
 * Complete participant
 * @deprecated Will be removed on 2024-09-01.
 */
export function completeParticipant(payload) {
    var _a = serializer(_completeParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_completeParticipantResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __completeParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.CompleteParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/complete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __completeParticipant.fromReq = fromReq;
    __completeParticipant.__isAmbassador = true;
    return __completeParticipant;
}
/** Exports data about participants as well as resolved steps in program. */
export function exportParticipantsStats(payload) {
    var _a = serializer(_exportParticipantsStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_exportParticipantsStatsResponse, {}).fromJSON;
    function __exportParticipantsStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantExportsService.ExportParticipantsStats',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantExportsServiceUrl({
                protoPath: '/v3/participants/export/{programId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __exportParticipantsStats.fromReq = fromReq;
    __exportParticipantsStats.__isAmbassador = true;
    return __exportParticipantsStats;
}
//# sourceMappingURL=http.impl.js.map